import { IApi } from "../interfaces/IApi";

/**
 * if want to call API, just do (example):
 *
 * const url = `${ApiService.Identity}/YourEndPointHere`;
 */

const BaseUrl = "https://api.apps.binus.ac.id/crr";

export const ApiService: IApi = {
  blob: "https://stresources.blob.core.windows.net/profilepicture",
  identity: "https://apim-bm7-dev.azure-api.net/func-identity-dev",
  organization: "https://apim-bm7-dev.azure-api.net/func-organization-dev",
  profile:
    "https://apim-mydashboardbinusmaya-dev.azure-api.net/func-mydashboardbinusmaya-profile-dev",
  dashboard:
    "https://apim-mydashboardbinusmaya-dev.azure-api.net/func-mydashboardbinusmaya-dashboard-dev",
  auth: {
    getToken: `${BaseUrl}/Auth/token`,
    getTokenMsal: `${BaseUrl}/Auth/token-msal`,
    getTokenBypass: `${BaseUrl}/Auth/token-bypass`,
  },
  apiHc: {
    getProfile: `${BaseUrl}/api-hc/get-profile`,
    getBULeader: `${BaseUrl}/api-hc/get-bu-leader`,
    getAreaLocation: `${BaseUrl}/api-hc/get-area-location`,
    getAutoCompleteBinusian: `${BaseUrl}/api-hc/get-auto-complete-binusian`,
  },
  apiFRM: {
    getBULeader: `${BaseUrl}/api-FRM/get-bu-leader`,
  },
  testing: {
    getTestingUser: `${BaseUrl}/MasterUser/testing`,
  },
  publicCDN: {
    getIconLogo: `${BaseUrl}/alesa-public-cdn/get-icon-logo`,
  },
  alesaDashboard: {
    getTop10_RequestData: `${BaseUrl}/alesa-dashboard/get-top-10-request`,
    getListOfRequest: `${BaseUrl}/alesa-dashboard/get-list-of-request`,
    deleteListOfRequest: `${BaseUrl}/alesa-dashboard/delete-list-of-request`,
    getListCrrReport: `${BaseUrl}/alesa-dashboard/get-list-crr-report`,
  },
  alesaForm: {
    getListRequestType: `${BaseUrl}/alesa-form/get-list-request-type`,
    getListRequestStatus: `${BaseUrl}/alesa-form/get-list-request-status`,
    getListDocumentType: `${BaseUrl}/alesa-form/get-list-document-type`,
    insertForm: `${BaseUrl}/alesa-form/insert-form`,
    editForm: `${BaseUrl}/alesa-form/edit-form`,
    editFormCorporateLegal: `${BaseUrl}/alesa-form/edit-form-corporate-legal`,
    editFormCorporateLegalFinish: `${BaseUrl}/alesa-form/edit-form-corporate-legal-finish`,
    pendingRejectCancelALESA: `${BaseUrl}/alesa-form/pending-reject-cancel-alesa`,
    EditFormCorporateLegalHardCopySK: `${BaseUrl}/alesa-form/edit-form-corporate-legal-hardcopy-sk`,
    editFormLegalRelationship: `${BaseUrl}/alesa-form/edit-form-legal-relationship`,
    sendBackFromLegalRelationship: `${BaseUrl}/alesa-form/send-back-from-legal-relationship`,
    downloadSingleFile: `${BaseUrl}/alesa-form/download-single-file`,
    downloadFileComment: `${BaseUrl}/alesa-form/download-file-comment`,
    getSingleDataRequest: `${BaseUrl}/alesa-form/get-single-data-request`,
    getSharepointToken: `${BaseUrl}/alesa-form/get-sharepoint-token`,
    getListUnderLevelStaff: `${BaseUrl}/alesa-form/get-list-under-level-staff`,
    getBase64GeneratePdf: `${BaseUrl}/alesa-form/get-base64-generate-pdf`,
    downloadFileRevision: `${BaseUrl}/alesa-form/download-file-revision`,
    requestRevisionByEndUser: `${BaseUrl}/alesa-form/request-revision-by-end-user`,
    getTransactionHistory: `${BaseUrl}/alesa-form/get-history`,
    uploadPreview: `${BaseUrl}/alesa-form/upload-preview`,
    deletePreview: `${BaseUrl}/alesa-form/delete-preview`,
    resendEmailFinishedForm: `${BaseUrl}/alesa-form/resend-email-finished-form`,
    downloadFileCommentMulti: `${BaseUrl}/alesa-form/download-file-comment-multi`,
    downloadFileRevisionMulti: `${BaseUrl}/alesa-form/download-file-revision-multi`,
  },
  profileUser: {
    getProfileSA: `${BaseUrl}/MasterUser/get-profile-sa`,
    getRoleNameProfileSA: `${BaseUrl}/MasterUser/get-role-name-profile-sa`,
    byPassProfileSA: `${BaseUrl}/MasterUser/get-by-pass`,
  },
  masterUser: {
    getListUsersSA: `${BaseUrl}/MasterUser/get-list-users-sa`,
    deleteSingleUserSA: `${BaseUrl}/MasterUser/delete-single-user-sa`,
    getListRolesNameSA: `${BaseUrl}/MasterUser/get-list-roles-name-sa`,
    editSingleUserSA: `${BaseUrl}/MasterUser/edit-single-user-sa`,
    getSearchListUsersSA: `${BaseUrl}/MasterUser/get-search-list-users-sa`,
  },
  masterRole: {
    getSingleRoleMenuListSA: `${BaseUrl}/MasterAccess/get-single-role-menu-list-sa`,
    editSingleRoleMenuListSA: `${BaseUrl}/MasterAccess/edit-single-role-menu-list-sa`,
    addSingleRoleMenuListSA: `${BaseUrl}/MasterAccess/add-single-role-menu-list-sa`,
    deleteSingleRoleSA: `${BaseUrl}/MasterAccess/delete-single-role-sa`,
    deleteMultipleRoleSA: `${BaseUrl}/MasterAccess/delete-multiple-role-sa`,
    listPrivilegeByRole: `${BaseUrl}/MasterAccess/list-privilege-by-role`,
    getSearchListRolesNameSA: `${BaseUrl}/MasterAccess/get-search-list-roles-name-sa`,
  },
  questionnaire: {
    getMasterQuestionnaire: `${BaseUrl}/questionnaire/get-master-questionnaire`,
    submitQuestionnaire: `${BaseUrl}/questionnaire/submit-questionnaire`,
    getRequestFinished: `${BaseUrl}/questionnaire/get-request-finished`,
    checkAccessUserQuestionaire: `${BaseUrl}/questionnaire/check-access-user-questionaire`,
    questionnaireReport: `${BaseUrl}/questionnaire/questionnaire-report`,
  },
  logError: {
    insert: `${BaseUrl}/log-error/insert-alesa`,
  },
};

export const subscriptionKeyLMSBM7 = "3036affa50694b0fb6ba6552772007c2";
export const subscriptionKeyMyDashboardBinusMaya =
  "c01143afab0f4501ac8c34f6586d6a94";
export const gaTrackingID = ""; /** dev */
export const TestMode = true;
export const REDPER = "";
export const ENVIRONMENT = "development";
